import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import TooltipField from 'hoc/TooltipField'

/* eslint-disable react/no-multi-comp */
class GridCellWithTooltip extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
  }
  onClick = e => {
    e.preventDefault()

    this.props.onCellSelected({
      api: this.props.api,
      columnApi: this.props.columnApi,
      data: this.props.data,
      node: this.props.node,
      rowIndex: this.props.rowIndex
    })
  }
  render() {
    return (
      <div>
        <a onClick={this.onClick}>
          <strong>{this.props.value}</strong>
        </a>
      </div>
    )
  }
}
class GridCellWrapper extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
  }
  constructor(...args) {
    super(...args)
    this.GridCellWithTooltip = TooltipField({
      recordNameKey: 'value',
      type: 'indexSearch',
      position: 'right-end',
      sensitivity: 100,
      timeout: 100
    })(GridCellWithTooltip)
  }
  render() {
    return React.createElement(this.GridCellWithTooltip, this.props)
  }
}

export default connect(null, null, null, { forwardRef: true })(GridCellWrapper)